import React from "react";
import FooterAboutUsComponent from "./FooterAboutUsComponent";
import FooterCategoriesRoutingComponent from "./FooterCategoriesRoutingComponent";
import FooterContactUsContainer from "./FooterContactUsContainer";
import useMobileScreen from "../../../hooks/useMobileScreen";

const FooterComponent = () => {
  const isMobileScreen = useMobileScreen();

  return (
    <footer className="footerContainer">
      <div className="footerContent">
        <FooterAboutUsComponent />
        <FooterCategoriesRoutingComponent />
        <FooterContactUsContainer />
      </div>
    </footer>
  );
};

export default FooterComponent;
